import leftSymbols from "@/assets/images/ActivitiesIcons/syncfusion/leftPanel";

import i18n from "@/i18n/index";

import store from "@/store";

const diagramExternalPluginList = store().getters["apps/getDiagramExternalPlugins"];
const activities = [
    {
        id: "TASK_PLUGIN",
        shape: {
            type: "Image",
            source: leftSymbols.TASK_PLUGIN,
            scale: "Meet"
        },
        text: i18n.t("diagrams.task")
    },
    {
        id: "APPROVAL_PLUGIN",
        shape: {
            type: "Image",
            source: leftSymbols.APPROVAL_PLUGIN,
            scale: "Meet"
        },
        text: i18n.t("diagrams.decisions")
    },
    {
        id: "EXTERNAL_PLUGIN",
        shape: {
            type: "Image",
            source: leftSymbols.EXTERNAL_PLUGIN,
            scale: "Meet"
        },
        text: i18n.t("diagrams.externalTask")
    },
    {
        id: "GENERATE_DOCUMENT_PLUGIN",
        shape: {
            type: "Image",
            source: leftSymbols.GENERATE_DOCUMENT_PLUGIN,
            scale: "Meet"
        },
        text: i18n.t("diagrams.generateDoc")
    },
    {
        id: "API_PLUGIN",
        shape: {
            type: "Image",
            source: leftSymbols.API_PLUGIN,
            scale: "Meet"
        },
        text: i18n.t("diagrams.callAPI")
    },
    {
        id: "BLOCKCHAIN_PLUGIN",
        shape: {
            type: "Image",
            source: leftSymbols.BLOCKCHAIN_PLUGIN,
            scale: "Meet"
        },
        text: i18n.t("diagrams.blockchain"),
        blockchain: true
    },
    // Hide data export until it is needed again
    // {
    //     id: "DATA_EXPORT_PLUGIN",
    //     shape: {
    //         type: "Image",
    //         source: leftSymbols.DATA_EXPORT_PLUGIN,
    //         scale: "Meet"
    //     },
    //     text: i18n.t("diagrams.dataExp")
    // },
    {
        id: "PROCESS_PLUGIN",
        shape: {
            type: "Image",
            source: leftSymbols.PROCESS_PLUGIN,
            scale: "Meet"
        },
        text: i18n.t("diagrams.process")
    },
    {
        id: "ADVANCED_LOGIC_PLUGIN",
        shape: {
            type: "Image",
            source: leftSymbols.ADVANCED_LOGIC_PLUGIN,
            scale: "Meet"
        },
        text: i18n.t("diagrams.advLogic")
    }
];

const events = [
    {
        id: "GENERAL_START_PLUGIN",
        shape: {
            type: "Image",
            source: leftSymbols.GENERAL_START_PLUGIN,
            scale: "Meet"
        },
        text: i18n.t("diagrams.start")
    },
    {
        id: "EXTERNAL_SOURCE_PLUGIN",
        shape: {
            type: "Image",
            source: leftSymbols.EXTERNAL_SOURCE_PLUGIN,
            scale: "Meet"
        },
        text: i18n.t("diagrams.startExt")
    },
    {
        id: "GENERAL_END_PLUGIN",
        shape: {
            type: "Image",
            source: leftSymbols.GENERAL_END_PLUGIN,
            scale: "Meet"
        },
        text: i18n.t("diagrams.end")
    },
    {
        id: "EXPOSE_API_PLUGIN",
        shape: {
            type: "Image",
            source: leftSymbols.EXPOSE_API_PLUGIN,
            scale: "Meet"
        },
        text: i18n.t("diagrams.expAPI")
    },
    {
        id: "BLOCKCHAIN_EVENT_PLUGIN",
        shape: {
            type: "Image",
            source: leftSymbols.BLOCKCHAIN_EVENT_PLUGIN,
            scale: "Meet"
        },
        text: i18n.t("diagrams.blockEv"),
        blockchain: true
    },
    {
        id: "START_BLOCKCHAIN_EVENT_PLUGIN",
        shape: {
            type: "Image",
            source: leftSymbols.START_BLOCKCHAIN_EVENT_PLUGIN,
            scale: "Meet"
        },
        text: i18n.t("diagrams.blockStart"),
        blockchain: true
    }
];

const gateways = [
    {
        id: "EXCLUSIVE_GATEWAY_PLUGIN",
        shape: {
            type: "Image",
            source: leftSymbols.EXCLUSIVE_GATEWAY_PLUGIN,
            scale: "Meet"
        },
        text: i18n.t("diagrams.exclusiveGate")
    },
    {
        id: "PARALLEL_GATEWAY_PLUGIN",
        shape: {
            type: "Image",
            source: leftSymbols.PARALLEL_GATEWAY_PLUGIN,
            scale: "Meet"
        },
        text: i18n.t("diagrams.parallelGate")
    },
    {
        id: "JOIN_GATEWAY_PLUGIN",
        shape: {
            type: "Image",
            source: leftSymbols.JOIN_GATEWAY_PLUGIN,
            scale: "Meet"
        },
        text: i18n.t("diagrams.joinGate")
    }
];

// left palette
function getpalettes(blockchain) {
    const discriminant = item => blockchain || Boolean(item.blockchain) === blockchain;
    return [
        {
            id: "activities",
            expanded: true,
            symbols: [...activities.filter(discriminant), ...diagramExternalPluginList.activities],
            title: i18n.t("diagrams.activities")
        },
        {
            id: "events",
            expanded: true,
            symbols: [...events.filter(discriminant), ...diagramExternalPluginList.events],
            title: i18n.t("diagrams.events")
        },
        {
            id: "gateways",
            expanded: true,
            symbols: [...gateways.filter(discriminant), ...diagramExternalPluginList.gateways],
            title: i18n.t("diagrams.gateways")
        }
    ];
}

export function paletteConfig(blockchain) {
    return {
        palettes: getpalettes(blockchain),
        width: "220",
        height: "100%",
        symbolWidth: 63,
        symbolHeight: 95,
        symbolMargin: { left: 7, right: 7, top: 0, bottom: 5 },
        expandMode: "Multiple",
        enableAnimation: true
    };
}
